import { createReducer, on } from '@ngrx/store';
import { reflectionsActions } from '../actions/reflections.actions';
import { Reflection } from '../models';
import { PaginationParams } from '../types';

export interface ReflectionsState {
    loaded: boolean | null;
    loading: boolean | null;
    reflections: Reflection[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: ReflectionsState = {
    loaded: null,
    loading: null,
    reflections: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const reflectionsReducer = createReducer(
    initialState,

    on(reflectionsActions.getReflections, (state, { value }): ReflectionsState => ({
        ...state,
        loading: true,
        page: value.page,
        limit: value.limit,
        lastParams: value,
    })),
    on(reflectionsActions.getReflectionsSuccess, (state, { payload, total }): ReflectionsState => ({
        ...state,
        loaded: true,
        loading: false,
        reflections: payload,
        total,
    })),
    on(reflectionsActions.getReflectionsError, (state): ReflectionsState => ({
        ...state,
        loaded: false,
        loading: false,
    })),

    on(reflectionsActions.clear, (): ReflectionsState => ({ ...initialState })),
);
